export {
    default as Heat,
    IHeatProps,
    THeatLevel,
} from './heat';
